import React from 'react';

import { createHashRouter } from 'react-router-dom';
import Layout from '../components/Layout';
import Analytics from '../routes/Analytics';
import Devices from '../routes/Devices';
import EditDeviceForm from '../routes/EditDeviceForm';
import EditObjectForm from '../routes/EditObjectForm';
import ErrorPage from '../routes/ErrorPage';
import NewDeviceForm from '../routes/NewDeviceForm';
import NewObjectForm from '../routes/NewObjectForm';
import ObjectMap from '../routes/ObjectMap';
import Objects from '../routes/Objects';
import Settings from '../routes/Settings';
import SingleObjectMap from '../routes/SingleObjectMap';
import Jobs from '../routes/Jobs';
import ProjectDropDown from '../components/ProjectDropDown';

const router = createHashRouter([
  {
    path: "/",
    element: <ProjectDropDown />,
  },
  {
    path: "/:projectId",
    element: <Layout />,
    children: [
      { index: true, element: <Objects /> },
      { path: "objects/new", element: <NewObjectForm /> },
      { path: "objects/:objectId", element: <EditObjectForm /> },
      { path: "devices", element: <Devices /> },
      { path: "devices/:deviceId", element: <EditDeviceForm /> },
      { path: "devices/new", element: <NewDeviceForm /> },
      { path: "analytics", element: <Analytics /> },
      { path: "jobs", element: <Jobs /> },
      { path: "map", element: <ObjectMap /> },
      { path: "map/:objectId", element: <SingleObjectMap /> },
      { path: "settings", element: <Settings /> },
      { path: "*", element: <ErrorPage msg="Page not found" /> },
    ],
  },
]);

export default router;